import { render, staticRenderFns } from "./UpgradeUser.vue?vue&type=template&id=6fc7bab4"
import script from "./UpgradeUser.vue?vue&type=script&lang=ts"
export * from "./UpgradeUser.vue?vue&type=script&lang=ts"
import style0 from "./UpgradeUser.vue?vue&type=style&index=0&id=6fc7bab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports